import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
//import { isAuthenticated } from '../../utils/auth';
import { getAccessToken, getUserRole } from '../../utils/auth';
import { CircularProgress } from '@mui/material';

const PrivateRoute = ({ children, role, ...rest }) => {
  const token = getAccessToken();

  if (!token) {
    // Hvis brugeren ikke er logget ind, omdiriger til login-siden
    return <Navigate to="/login" />;
  }

  // Hent brugerens rolle fra tokenet
  const userRole = getUserRole(token);

  if (role) {
    // Hvis en rolle er angivet, tjek om brugeren har den nødvendige rolle
    const requiredRoles = Array.isArray(role) ? role : [role];
    if (!requiredRoles.includes(userRole)) {
      // Hvis brugeren ikke har den nødvendige rolle, omdiriger til en "Adgang nægtet" side
      return <Navigate to="/login" />;
    }
  }

  // Hvis alt er i orden, render børnene
  return children;
};

export default PrivateRoute;
